module.exports = __webpack_public_path__ + "img/ss4.6d19ffe5.jpg";